var take = require('../take');

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_staging/shared/~/ramda/src/internal/_dropLast.js
// module id = 205
// module chunks = 0 2 3 4 5 6 7